import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  IAutoDebitAccountPostResponse,
  IAutoDebitAccountsResponse,
  IGetAutoDebitAccountBody,
  IPostAutoDebitAccountBody,
} from '../models/automaticDebits.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AutomaticDebitService {
  private apiUrl = `${environment.HttpUrl}/RegisterAccount`;

  constructor(private http: HttpClient) {}

  postAutoDebitAccount(
    data: IPostAutoDebitAccountBody
  ): Observable<IAutoDebitAccountPostResponse> {
    return this.http.post<IAutoDebitAccountPostResponse>(this.apiUrl, data);
  }

  getAutoDebitAccount(
    data: IGetAutoDebitAccountBody
  ): Observable<IAutoDebitAccountsResponse> {
    return this.http.post<IAutoDebitAccountsResponse>(this.apiUrl, data);
  }

  // deleteDebitAccount(
  //   data: IDeleteDebitAccountBody
  // ): Observable<IDebitAccountMessageResponse> {
  //   return this.http.post<IDebitAccountMessageResponse>(this.apiUrl, data);
  // }
}
